export function convertToDate(_strDate: string | Date | undefined | null): Date {
  try {
    if (_strDate instanceof Date) {
      return isNaN(_strDate.getTime()) ? new Date() : _strDate;
    }
    if (!_strDate) return new Date();
    const parsedDate = new Date(_strDate as string);
    return isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
  } catch (error) {
    console.error(error);
    return new Date();
  }
}